import {
  DragDropContext,
  Draggable,
  DropResult,
  Droppable,
} from "@hello-pangea/dnd";
import { Add, DragIndicator } from "@mui/icons-material";
import { Grid, IconButton, TextField, Typography } from "@mui/material";
import React from "react";
import { TrashIcon } from "src/grading/assets";

export type Question = {
  question: string;
  newQuestion?: boolean;
};

interface ProfileQuestionsProps {
  questions: Question[];
  onChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number,
    isFeedbackQuestion?: boolean,
  ) => void;
  onSubmit: (
    isFeedbackQuestion?: boolean,
    newQuestionsOrder?: Question[],
  ) => void;
  onDelete: (index: number, isFeedbackQuestion?: boolean) => void;
  onAdd: (isFeedbackQuestion?: boolean) => void;
  setQuestions: (questions: Question[]) => void;
  isFeedbackQuestion?: boolean;
}

export const ProfileQuestions = ({
  questions,
  onChange,
  onSubmit,
  onDelete,
  onAdd,
  setQuestions,
  isFeedbackQuestion,
}: ProfileQuestionsProps) => {
  const onDragEnd = (result: DropResult) => {
    // Don't do anything if dropped outside the list
    if (!result.destination) return;

    // Don't do anything if dropped in the same position
    if (
      result.destination.droppableId === result.source.droppableId &&
      result.destination.index === result.source.index
    ) {
      return;
    }

    const newQuestionOrder = Array.from(questions || []);
    const [reorderedItem] = newQuestionOrder.splice(result.source.index, 1);
    newQuestionOrder.splice(result.destination.index, 0, reorderedItem);
    setQuestions(newQuestionOrder);
    onSubmit(isFeedbackQuestion, newQuestionOrder);
  };
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="questions" key={"questions"}>
        {(provided, snapshot) => {
          return (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={{
                position: "relative",
                width: "100%",
                minHeight: snapshot.isDraggingOver ? "100px" : "auto",
                transition: "background-color 0.2s ease",
                backgroundColor: snapshot.isDraggingOver
                  ? "rgba(0, 0, 0, 0.05)"
                  : "transparent",
              }}
            >
              <Grid container alignItems={"center"} rowGap={2}>
                {questions.map((question, index) => {
                  return question.newQuestion ? (
                    <Grid
                      container
                      alignItems={"center"}
                      flexDirection={"row"}
                      key={`question${index}`}
                      spacing={2}
                    >
                      <Grid container item flex={1}>
                        <TextField
                          variant="standard"
                          fullWidth
                          value={question.question}
                          onChange={(e) =>
                            onChange(e, index, isFeedbackQuestion)
                          }
                          onBlur={() => onSubmit(isFeedbackQuestion)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              onSubmit(isFeedbackQuestion);
                            }
                          }}
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    <Draggable
                      draggableId={index.toString()}
                      index={index}
                      key={index.toString()}
                    >
                      {(provided, snapshot) => {
                        return (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            style={{
                              ...provided.draggableProps.style,
                              width: "100%",
                            }}
                          >
                            <Grid
                              container
                              alignItems={"center"}
                              flexDirection={"row"}
                              key={`question${index}`}
                              spacing={2}
                            >
                              <div {...provided.dragHandleProps}>
                                <DragIndicator />
                              </div>
                              <Typography variant="caption">
                                {question.question}
                              </Typography>

                              <IconButton
                                onClick={() =>
                                  onDelete(index, isFeedbackQuestion)
                                }
                                sx={{ marginLeft: "auto" }}
                              >
                                <TrashIcon stroke="#000" />
                              </IconButton>
                            </Grid>
                          </div>
                        );
                      }}
                    </Draggable>
                  );
                })}

                {provided.placeholder}

                <Grid container>
                  <IconButton
                    onClick={() => {
                      console.log("isFeedbackQuestion", isFeedbackQuestion);
                      onAdd(isFeedbackQuestion);
                    }}
                    sx={{
                      alignItems: "center",
                      color: "#000",
                      paddingLeft: "8px",
                      columnGap: "8px",
                    }}
                  >
                    <Add />
                    <Typography
                      variant="caption"
                      textTransform={"uppercase"}
                      fontWeight={"bold"}
                      fontSize={"14px"}
                    >
                      Add question
                    </Typography>
                  </IconButton>
                </Grid>
              </Grid>
            </div>
          );
        }}
      </Droppable>
    </DragDropContext>
  );
};

export default ProfileQuestions;
